import { useEffect, useRef, useState } from 'react';

export function useSignatureCanvas() {
  const [isSignatureDisabled, setIsSignatureDisabled] = useState(false);
  const signatureTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleSignatureDraw = () => {
    // Clear existing timeout
    if (signatureTimeoutRef.current) {
      clearTimeout(signatureTimeoutRef.current);
    }

    // Set new timeout to disable canvas after 1.5 seconds
    signatureTimeoutRef.current = setTimeout(() => {
      setIsSignatureDisabled(true);
    }, 1000);
  };

  const handleSignatureClear = () => {
    // Clear timeout and re-enable canvas
    if (signatureTimeoutRef.current) {
      clearTimeout(signatureTimeoutRef.current);
      signatureTimeoutRef.current = null;
    }
    setIsSignatureDisabled(false);
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (signatureTimeoutRef.current) {
        clearTimeout(signatureTimeoutRef.current);
      }
    };
  }, []);

  return {
    isSignatureDisabled,
    handleSignatureDraw,
    handleSignatureClear,
  };
}
